// removed by extract-text-webpack-plugin
module.exports = {"choreListContainer":"_18sBwdkEv_tIxoKA348kjS","resetContainer":"_1YHcSWjwT9Yaande02syYW","addChore":"_3lx60X-aC1yT5zkK-XzaqJ","chartExplainBox":"_3t4nkk5sp9ApT3ldqnqvPq","explainText":"_3XcRnLgDWuImIqBVDUFwv9","iconContain":"_3C7rZCVpD0P4u9LUOJPuww","choreIcon":"_2eD1fJVcxTVGvagisikYCj","internalNavLink":"_1o1srFzEOFYnyZBzBPspjy","choreButtonContainer":"axs6DWf7fpwGgIsZHBpjx"};


//////////////////
// WEBPACK FOOTER
// ./src/componentStyles/ChoreList.css
// module id = 378
// module chunks = 0